export default {
	appBase: ''
}
